<template>
  <div v-if="newVisits.length > 0" class="new-visits-view">
    <p>
      You have recently created visits available to submit. Please click on the
      link below to submit the EIR – Electronic Inspection Report.
    </p>
    <div
      v-for="visit in newVisits"
      :key="visit.visitId"
      class="new-visits-view__row"
    >
      <a
        @click="onNewVisitLinkClicked(visit.visitId, visit.visitType)"
        class="new-visits-view__link"
      >
        <span
          >{{ visit.plantName }} -
          {{ EnumVisitType[visit.visitType].replace(/([A-Z])/g, " $1") }}</span
        >
      </a>
      <font-awesome-icon
        class="update-visit-action"
        icon="fa-solid fa-sync"
        :spin="refreshingVisitIds.includes(visit.visitId)"
        @click="refreshNewVisitStatusAsync(visit.visitId)"
        data-cy="update-visit-action"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { EnumVisitType } from "@/Domain/EnumVisitType";
import { NewVisitsService } from "@/shared/services/NewVisitsService";
import { ref } from "vue";
import { api } from "@/api";
import { handleResponsePromiseAsync } from "@/shared/helpers/apiHelper";
import { CacheService } from "@/shared/services/CacheService";

const refreshingVisitIds = ref<number[]>([]);
const newVisits = ref(NewVisitsService.getNewVisits());

// Check if visit EIR has been submitted
const refreshNewVisitStatusAsync = async function (visitId: number) {
  if (refreshingVisitIds.value.includes(visitId)) return;
  refreshingVisitIds.value.push(visitId);

  const visitReportPromise = api.get("GetEirDisplayReport", {
    visitId: Number(visitId),
  });

  await handleResponsePromiseAsync(
    visitReportPromise,
    (data) => {
      // If report exists, remove visit from new visits list
      if (data) {
        NewVisitsService.removeNewVisit(visitId);
        newVisits.value = NewVisitsService.getNewVisits();
      }
    },
    "NewVisitsView.vue",
    "refreshNewVisitStatusAsync"
  );

  refreshingVisitIds.value = refreshingVisitIds.value.filter(
    (id) => id !== visitId
  );
};

const getVisitUrl = function (visitType: EnumVisitType) {
  let subType = "short";
  if (visitType == EnumVisitType.Regular) subType = "long";
  return `RfrVisitInspectionForm?category=Inspection&mode=new&subtype=${subType}&menu=VisitsAsRfr`;
};

const onNewVisitLinkClicked = function (
  visitId: number,
  visitType: EnumVisitType
) {
  CacheService.set("RfrVisitInspectionFormId", visitId);
  window.location.href = getVisitUrl(visitType);
};
</script>

<style lang="scss">
.new-visits-view {
  margin-bottom: 20px;
  padding: 10px;
  border: 1px solid #dc3545;
  border-radius: 5px;
  background-color: #f5f5f5;
  font-weight: bold;

  p {
    color: #dc3545;
  }

  &__row {
    display: flex;
    align-items: center;
    gap: 8px;
    align-items: baseline;
  }

  &__link {
    display: block;
    margin-top: 8px;
    font-weight: bold;
    cursor: pointer;

    &:hover {
      color: #007bff;
    }
  }

  .update-visit-action {
    cursor: pointer;
  }
}
</style>
